// Module
var code = "<style>:host{width:100px;height:100px;container:inline-size}.working{height:100%;width:100%;background-color:orange}@container (width > 650px){.working{background-color:#0ff}}</style> <div class=\"working\"></div>";
// Exports
export default code;